/* ===================================================================
       LITTLE PHUKET — Logique du configurateur (vanilla JS)
       =================================================================== */
    (function () {
      'use strict';
      var state = {};
      var PRICE_BASE = 25.00;
      var PRICE_OPT = 2.00;
      var PRODUCT_IMAGES = [];

      /* Options payantes (+2 € chacune). Couleurs/taille non comptées. */
      function countOptions() {
        var n = 0;
        if (state.logo_coeur_g) n++;
        if (state.logo_coeur_d) n++;
        if ((state.central_type === 'logo' && state.logo_central) || (state.central_type === 'texte' && state.central_texte)) n++;
        if (state.logo_epaule_d) n++;
        if (state.logo_epaule_g) n++;
        if (state.dos_nom) n++;
        if ((state.dos_type === 'numero' && state.dos_numero) || (state.dos_type === 'logo' && state.logo_dos)) n++;
        if ((state.bas_type === 'texte' && state.bas_texte) || (state.bas_type === 'logo' && state.logo_bas)) n++;
        return n;
      }
      function flocSurcharge() { return parseFloat(state.flocage_price || 0) || 0; }

      /* ---------- Sélection : grilles + pastilles ---------- */
      function bindSelectables() {
        document.querySelectorAll('.lp-grid, .lp-choices').forEach(function (box) {
          box.addEventListener('click', function (e) {
            var btn = e.target.closest('.lp-cell, .lp-choice');
            if (!btn || !box.contains(btn)) return;
            var group = btn.getAttribute('data-group');
            box.querySelectorAll('.lp-cell, .lp-choice').forEach(function (b) {
              b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
            state[group] = btn.getAttribute('data-value') || '';
            var im = btn.querySelector('img');
            state[group + '_img'] = im ? im.getAttribute('src') : '';
            if (group === 'couleur_maillot' && btn.dataset.color) setJersey(btn.dataset.color, state[group]);
            if (group === 'couleur_flocage') {
              state.flocage_price = btn.dataset.price || 0;
              state.couleur_flocage_color = btn.dataset.color || '';
              setFlockColor(btn.dataset.color || '#111111');
            }
            updateBadge(group, btn);
            maybeSwitchView(group);
            refresh();
          });
        });
      }

      function setJersey(hex, name) {
        var stage = document.querySelector('.lp-preview__stage');
        if (stage) {
          stage.style.setProperty('--jersey-color', hex);
        }
        var n = document.getElementById('lp-jersey-name');
        if (n && name) n.textContent = name;
      }
      function setFlockColor(hex) {
        var stage = document.querySelector('.lp-preview__stage');
        if (!stage) return;
        stage.style.setProperty('--flock-color', hex || '#111111');
      }
      function normalizeLabel(value) {
        return String(value || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }
      function imageSearchText(image) {
        var src = String((image && image.src) || '');
        var file = src.split('?')[0].split('/').pop() || '';
        file = file.replace(/\.[a-z0-9]+$/i, '');
        return normalizeLabel(((image && image.alt) || '') + ' ' + file);
      }
      function isBackLabel(label) {
        return /(^|\s)(arriere|dos|back|rear)(\s|$)/.test(label);
      }
      function isFrontLabel(label) {
        return /(^|\s)(avant|front)(\s|$)/.test(label);
      }
      function findImageForColor(colorName, face) {
        var normalizedColor = normalizeLabel(colorName);
        if (!normalizedColor || !PRODUCT_IMAGES.length) return null;
        var matcher = face === 'arriere' ? isBackLabel : isFrontLabel;
        var exact = PRODUCT_IMAGES.find(function (image) {
          var text = imageSearchText(image);
          return text && text.indexOf(normalizedColor) !== -1 && matcher(text);
        });
        if (exact) return exact;
        return PRODUCT_IMAGES.find(function (image) {
          var text = imageSearchText(image);
          return text && text.indexOf(normalizedColor) !== -1;
        }) || null;
      }
      function swapFaceImage(face, src, alt) {
        var image = document.querySelector('.lp-face--' + face + ' .lp-face__img');
        if (!image || !src) return;
        image.src = src;
        if (alt) image.alt = alt;
      }
      function updatePreviewImages(frontSrc) {
        var selectedColor = state.couleur_maillot;
        var frontMatch = findImageForColor(selectedColor, 'avant');
        var backMatch = findImageForColor(selectedColor, 'arriere');
        var frontImage = document.querySelector('.lp-face--avant .lp-face__img');
        var backImage = document.querySelector('.lp-face--arriere .lp-face__img');

        if (frontImage) {
          swapFaceImage('avant',
            (frontMatch && frontMatch.src) || frontSrc || frontImage.getAttribute('data-default-src') || frontImage.src,
            frontMatch && frontMatch.alt
          );
        }

        if (backImage) {
          swapFaceImage('arriere',
            (backMatch && backMatch.src) || backImage.getAttribute('data-default-src') || backImage.src,
            backMatch && backMatch.alt
          );
        }
      }
      function contrastColor(hex) {
        var h = String(hex || '').replace('#', '');
        if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
        var r = parseInt(h.substr(0,2),16), g = parseInt(h.substr(2,2),16), b = parseInt(h.substr(4,2),16);
        if (isNaN(r) || isNaN(g) || isNaN(b)) return '#111111';
        var lum = 0.299*r + 0.587*g + 0.114*b;        // luminance perçue
        return lum < 140 ? '#ffffff' : '#111111';      // foncé -> blanc, clair -> noir
      }

      /* ---------- Vue Avant / Arrière ---------- */
      function setView(v) {
        document.querySelectorAll('.lp-face').forEach(function (f) { f.hidden = f.getAttribute('data-view') !== v; });
        document.querySelectorAll('.lp-view-toggle button').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-view') === v);
        });
      }
      function bindView() {
        document.querySelectorAll('.lp-view-toggle button').forEach(function (b) {
          b.addEventListener('click', function () { setView(b.getAttribute('data-view')); });
        });
      }
      var BACK_KEYS = ['logo_dos', 'dos_nom', 'dos_numero', 'dos_type', 'bas_texte', 'logo_bas', 'bas_type'];
      var FRONT_KEYS = ['logo_coeur_g', 'logo_coeur_d', 'logo_central', 'central_texte', 'central_type',
                        'logo_epaule_d', 'logo_epaule_g', 'couleur_maillot'];
      function maybeSwitchView(key) {
        if (BACK_KEYS.indexOf(key) >= 0) setView('arriere');
        else if (FRONT_KEYS.indexOf(key) >= 0) setView('avant');
      }

      function updateBadge(group, btn) {
        var badge = document.querySelector('[data-badge-for="' + group + '"]');
        if (!badge) return;
        var none = btn.getAttribute('data-none') === 'true';
        var label = none ? 'Pas de Logo' : (btn.getAttribute('data-value') || btn.getAttribute('aria-label') || '—');
        if (!none && /\.png$/.test(label)) label = shortName(label);
        badge.textContent = label || '—';
        badge.classList.toggle('is-set', !none && !!label);
      }

      function bindToggles() {
        document.querySelectorAll('.lp-toggle').forEach(function (toggle) {
          toggle.addEventListener('click', function (e) {
            var opt = e.target.closest('.lp-toggle__opt');
            if (!opt) return;
            var name = opt.getAttribute('data-toggle');
            toggle.querySelectorAll('.lp-toggle__opt').forEach(function (o) {
              o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false');
            });
            opt.classList.add('is-active'); opt.setAttribute('aria-pressed', 'true');
            state[name] = opt.getAttribute('data-value');
            applyConditionals(); maybeSwitchView(name); refresh();
          });
        });
      }

      function bindInputs() {
        document.querySelectorAll('.lp-input').forEach(function (input) {
          input.addEventListener('input', function () {
            state[input.name] = input.value; maybeSwitchView(input.name); refresh();
          });
          if (input.value) state[input.name] = input.value;
        });
      }

      function applyConditionals() {
        document.querySelectorAll('[data-when]').forEach(function (el) {
          var c = el.getAttribute('data-when').split('=');
          el.hidden = state[c[0]] !== c[1];
        });
      }

      /* ---------- Aperçu : rendu texte (police flocage) + logos ---------- */
      function fillZone(sel, content, filled) {
        var z = document.querySelector(sel); if (!z) return;
        z.innerHTML = content; z.classList.toggle('is-filled', !!filled);
      }
      function flockTxt(t) { return '<span class="lp-flock-text">' + escapeHtml(t) + '</span>'; }
      function zoneImg(src) { return src ? '<img src="' + src + '" alt="">' : ''; }

      function updatePreview() {
        // AVANT
        fillZone('.z-coeur-g', state.logo_coeur_g ? zoneImg(state.logo_coeur_g_img) : 'Cœur G', state.logo_coeur_g);
        fillZone('.z-coeur-d', state.logo_coeur_d ? zoneImg(state.logo_coeur_d_img) : 'Cœur D', state.logo_coeur_d);
        if (state.central_type === 'texte' && state.central_texte) fillZone('.z-centre', flockTxt(state.central_texte), true);
        else if (state.central_type === 'logo' && state.logo_central) fillZone('.z-centre', zoneImg(state.logo_central_img), true);
        else fillZone('.z-centre', 'Central', false);
        // Épaule droite
        if (state.logo_epaule_d) fillZone('.z-epaule-d', zoneImg(state.logo_epaule_d_img), true);
        else fillZone('.z-epaule-d', 'Ép. D', false);
        // Épaule gauche
        if (state.logo_epaule_g) fillZone('.z-epaule-g', zoneImg(state.logo_epaule_g_img), true);
        else fillZone('.z-epaule-g', 'Ép. G', false);
        // ARRIÈRE
        fillZone('.z-dos-nom', state.dos_nom ? flockTxt(state.dos_nom) : 'Nom', state.dos_nom);
        if (state.dos_type === 'numero' && state.dos_numero) fillZone('.z-dos-num', flockTxt(state.dos_numero), true);
        else if (state.dos_type === 'logo' && state.logo_dos) fillZone('.z-dos-num', zoneImg(state.logo_dos_img), true);
        else fillZone('.z-dos-num', 'Numéro / Logo', false);
        if (state.bas_type === 'texte' && state.bas_texte) fillZone('.z-dos-badge', flockTxt(state.bas_texte), true);
        else if (state.bas_type === 'logo' && state.logo_bas) fillZone('.z-dos-badge', zoneImg(state.logo_bas_img), true);
        else fillZone('.z-dos-badge', 'Bas du dos', false);
      }

      /* ---------- Récapitulatif + total ---------- */
      function refresh() {
        applyConditionals();
        updatePreview();
        var list = document.getElementById('lp-summary-list');
        if (list) {
          var rows = [];
          function add(k, v) { if (v) rows.push([k, v]); }
          add('Couleur maillot', state.couleur_maillot);
          add('Taille', state.taille);
          add('Logo Cœur Gauche', shortName(state.logo_coeur_g));
          add('Logo Cœur Droit', shortName(state.logo_coeur_d));
          add('Central', state.central_type === 'logo' ? shortName(state.logo_central) : state.central_texte);
          add('Épaule Droite', shortName(state.logo_epaule_d));
          add('Épaule Gauche', shortName(state.logo_epaule_g));
          add('Nom Dos', state.dos_nom);
          add(state.dos_type === 'numero' ? 'N° Dos' : 'Logo Dos',
              state.dos_type === 'numero' ? state.dos_numero : shortName(state.logo_dos));
          add('Bas du dos', state.bas_type === 'texte' ? state.bas_texte : shortName(state.logo_bas));
          add('Couleur flocage', state.couleur_flocage);
          list.innerHTML = rows.map(function (r) {
            return '<li><span class="lp-summary__k">' + r[0] + '</span><span class="lp-summary__v">' + escapeHtml(r[1]) + '</span></li>';
          }).join('') || '<li><span class="lp-summary__k">Aucune personnalisation</span></li>';
        }
        var opts = countOptions();
        var total = PRICE_BASE + opts * PRICE_OPT + flocSurcharge();
        var totalEl = document.getElementById('lp-total');
        if (totalEl) totalEl.textContent = total.toFixed(2).replace('.', ',') + ' €';
        var note = document.getElementById('lp-total-note');
        if (note) {
          var t = PRICE_BASE.toFixed(2).replace('.', ',') + ' € + ' + opts + ' option' + (opts > 1 ? 's' : '')
                + ' × ' + PRICE_OPT.toFixed(2).replace('.', ',') + ' €';
          if (flocSurcharge() > 0) t += ' + flocage réfléchissant ' + flocSurcharge().toFixed(2).replace('.', ',') + ' €';
          note.textContent = t;
        }
        applyVariant();
        syncCartProperties();
      }

      function shortName(f) {
        if (!f) return '';
        return /\.png$/.test(f) ? f.replace(/^logo_/, '').replace(/\.png$/, '').replace(/_/g, ' ') : f;
      }
      function escapeHtml(s) {
        return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
      }

      function syncCartProperties() {
        var holder = document.querySelector('form[action*="/cart/add"]') || document.getElementById('lp-properties');
        if (!holder) return;
        holder.querySelectorAll('input[data-lp-prop]').forEach(function (n) { n.remove(); });
        var props = {
          'Couleur maillot': state.couleur_maillot,
          'Taille': state.taille,
          'Logo Cœur Gauche': state.logo_coeur_g,
          'Logo Cœur Droit': state.logo_coeur_d,
          'Flocage Central': state.central_type === 'logo' ? state.logo_central : state.central_texte,
          'Épaule Droite': state.logo_epaule_d,
          'Épaule Gauche': state.logo_epaule_g,
          'Nom Dos': state.dos_nom,
          'Dos': state.dos_type === 'numero' ? state.dos_numero : state.logo_dos,
          'Bas du dos': state.bas_type === 'texte' ? state.bas_texte : state.logo_bas,
          'Couleur flocage': state.couleur_flocage
        };
        Object.keys(props).forEach(function (k) {
          if (!props[k]) return;
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = props[k];
          i.setAttribute('data-lp-prop', '1'); holder.appendChild(i);
        });
      }

      function seedInitialState() {
        document.querySelectorAll('.lp-toggle__opt.is-active').forEach(function (o) {
          state[o.getAttribute('data-toggle')] = o.getAttribute('data-value');
        });
        document.querySelectorAll('.lp-cell.is-selected, .lp-choice.is-selected').forEach(function (c) {
          state[c.getAttribute('data-group')] = c.getAttribute('data-value') || '';
          if (c.dataset.price) {
            state.flocage_price = c.dataset.price;
            state.couleur_flocage_color = c.dataset.color || '';
          }
        });
        var col = document.querySelector('.lp-choice.is-selected[data-group="couleur_maillot"]');
        if (col && col.dataset.color) setJersey(col.dataset.color, col.getAttribute('data-value'));
        var flock = document.querySelector('.lp-choice.is-selected[data-group="couleur_flocage"]');
        if (flock) setFlockColor(flock.dataset.color || '#111111');

      }

      function init() {
        var formEl = document.getElementById('lp-form');
        if (formEl) {
          if (formEl.dataset.basePrice) PRICE_BASE = parseFloat(formEl.dataset.basePrice) || PRICE_BASE;
          if (formEl.dataset.optPrice) PRICE_OPT = parseFloat(formEl.dataset.optPrice) || PRICE_OPT;
          if (formEl.dataset.flockScale) {
            var st = document.querySelector('.lp-preview__stage');
            if (st) st.style.setProperty('--flock-scale', formEl.dataset.flockScale);
          }
        }
        bindSelectables(); bindToggles(); bindInputs(); bindView(); initVariants();
        seedInitialState(); applyConditionals(); refresh();
        initStepper(); initModal();
      }
      document.addEventListener('DOMContentLoaded', init);


      /* ===================================================================
         ███  BLOC STEPPER MOBILE  ███
         =================================================================== */
      var stepper = { steps: [], idx: 0, on: false, mq: null };
      function initStepper() {
        var form = document.getElementById('lp-form');
        stepper.steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
        stepper.mq = window.matchMedia('(max-width: 768px)');
        if (stepper.mq.addEventListener) stepper.mq.addEventListener('change', handleMq); else stepper.mq.addListener(handleMq);
        handleMq();
        var prev = document.getElementById('lp-step-prev');
        var next = document.getElementById('lp-step-next');
        if (prev) prev.addEventListener('click', function () { goStep(stepper.idx - 1); });
        if (next) next.addEventListener('click', function () {
          if (next.getAttribute('data-done') === '1') { if (window.__lpCloseModal) window.__lpCloseModal(); }
          else goStep(stepper.idx + 1);
        });
      }
      function handleMq() {
        var form = document.getElementById('lp-form');
        stepper.on = stepper.mq.matches;
        form.classList.toggle('lp-form--stepper', stepper.on);
        if (stepper.on) { stepper.idx = Math.min(stepper.idx, stepper.steps.length - 1); showStep(); } else clearStep();
      }
      function clearStep() { stepper.steps.forEach(function (s) { s.classList.remove('is-current'); }); }
      function goStep(i) {
        if (i < 0 || i >= stepper.steps.length) return;
        stepper.idx = i; showStep();
        var body = document.querySelector('.lp-modal__body') || window;
        if (body.scrollTo) body.scrollTo({ top: 0, behavior: 'smooth' });
      }
      function showStep() {
        var total = stepper.steps.length;
        stepper.steps.forEach(function (s, i) { s.classList.toggle('is-current', i === stepper.idx); });
        var count = document.getElementById('lp-step-count');
        var fill = document.getElementById('lp-step-fill');
        if (count) count.textContent = 'Étape ' + (stepper.idx + 1) + ' / ' + total;
        if (fill) fill.style.width = ((stepper.idx + 1) / total * 100) + '%';
        var prev = document.getElementById('lp-step-prev');
        var next = document.getElementById('lp-step-next');
        if (prev) prev.disabled = stepper.idx === 0;
        if (next) {
          var last = stepper.idx === total - 1;
          next.textContent = last ? '✓' : '›';
          next.setAttribute('data-done', last ? '1' : '0');
          next.setAttribute('aria-label', last ? 'Valider' : 'Étape suivante');
        }
      }
      /* ███  FIN STEPPER  ███ */

      /* ===================================================================
         ███  BLOC MODALE  ███
         =================================================================== */
      function initModal() {
        var openBtn = document.getElementById('lp-open');
        var modal = document.getElementById('lp-modal');
        if (!openBtn || !modal) return;
        function open() { modal.hidden = false; document.body.classList.add('lp-modal-open'); if (stepper.on) { stepper.idx = 0; showStep(); } }
        function close() { modal.hidden = true; document.body.classList.remove('lp-modal-open'); }
        window.__lpCloseModal = close;
        openBtn.addEventListener('click', open);
        modal.querySelectorAll('[data-lp-close]').forEach(function (b) { b.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
      }
      /* ███  FIN MODALE  ███ */

      /* ===================================================================
         ███  BLOC VARIANTES SHOPIFY  ███
         =================================================================== */
      var VARIANTS = null, OPT_COLOR_IDX = -1, OPT_SIZE_IDX = -1;
      function initVariants() {
        var el = document.getElementById('lp-variants');
        var imagesEl = document.getElementById('lp-product-images');
        var f = document.getElementById('lp-form');
        if (!el || !f) return;
        try { VARIANTS = JSON.parse(el.textContent); } catch (e) { VARIANTS = null; return; }
        try { PRODUCT_IMAGES = imagesEl ? JSON.parse(imagesEl.textContent) : []; } catch (e) { PRODUCT_IMAGES = []; }
        OPT_COLOR_IDX = parseInt(f.dataset.colorIdx, 10); if (isNaN(OPT_COLOR_IDX)) OPT_COLOR_IDX = -1;
        OPT_SIZE_IDX = parseInt(f.dataset.sizeIdx, 10); if (isNaN(OPT_SIZE_IDX)) OPT_SIZE_IDX = -1;
      }
      function matchVariant() {
        if (!VARIANTS) return null;
        for (var i = 0; i < VARIANTS.length; i++) {
          var v = VARIANTS[i], ok = true;
          if (OPT_COLOR_IDX >= 0 && state.couleur_maillot) ok = ok && v.options[OPT_COLOR_IDX] === state.couleur_maillot;
          if (OPT_SIZE_IDX >= 0 && state.taille) ok = ok && v.options[OPT_SIZE_IDX] === state.taille;
          if (ok) return v;
        }
        return null;
      }
      function applyVariant() {
        var v = matchVariant(); if (!v) return;
        var f = document.getElementById('lp-form'); if (f) f.dataset.productId = String(v.id);
        var sel = document.querySelector('form[action*="/cart/add"] [name="id"]'); if (sel) sel.value = v.id;
        updatePreviewImages(v.featured_image && v.featured_image.src ? v.featured_image.src : '');
      }
      /* ███  FIN VARIANTES  ███ */

    })();
